import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const Booking = () => {
  const { t } = useLanguage();
  return (
    <section id="booking" data-testid="booking-section" className="relative py-24 lg:py-36 overflow-hidden">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
        className="absolute inset-0"
      >
        <img
          src="/assets/photo-08.webp"
          alt={t.booking.photoLabel}
          data-testid="photo-slot-08"
          className="w-full h-full object-cover object-[45%_20%]"
        />
        <div className="absolute inset-0 bg-ink/72 lg:bg-transparent" />
        <div className="absolute inset-0 lg:bg-[linear-gradient(90deg,rgba(11,11,12,0.88)_0%,rgba(11,11,12,0.5)_40%,rgba(11,11,12,0.08)_75%,transparent_100%)]" />
        <div className="absolute inset-0 bg-gradient-to-b from-ink/90 via-transparent to-ink/90" />
      </motion.div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <div className="max-w-2xl">
          <Reveal>
            <p className="mt-4 font-serif italic text-lg sm:text-xl text-champagne">{t.booking.kicker}</p>
          </Reveal>

          <div className="mt-10 grid gap-8">
            <Reveal delay={0.1}>
              <p data-testid="booking-lead1" className="text-ivory/90 font-light leading-relaxed">{t.booking.lead1}</p>
            </Reveal>
            <Reveal delay={0.2}>
              <p data-testid="booking-lead2" className="text-ivory/90 font-light leading-relaxed">{t.booking.lead2}</p>
            </Reveal>
            <Reveal delay={0.25}>
              <p data-testid="booking-tags" className="gc-eyebrow !tracking-[0.18em] !normal-case !text-[11px]">{t.booking.tags}</p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
